<template>
  <v-app id="inspire">
    <admin-navigation-menu v-model="drawer" />

    <v-toolbar :clipped-left="$vuetify.breakpoint.lgAndUp" color="primary" dark app fixed>
      <v-toolbar-title style="width: 300px" class="ml-0 pl-3">
        <!--<v-toolbar-side-icon @click.stop="drawer = !drawer" class="hidden-xs-and-up"></v-toolbar-side-icon>-->
        <span></span>
      </v-toolbar-title>
      <v-text-field
        disabled
        flat
        solo-inverted
        hide-details
        prepend-inner-icon="search"
        label="Buscar"
        class="hidden-sm-and-down"
        v-model="search"
      ></v-text-field>
      <v-spacer></v-spacer>
      <span>{{userEmail}}</span>
      <v-toolbar-items>
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-btn icon @click.stop="logout"  v-on="on">
              <v-icon>exit_to_app</v-icon>
            </v-btn>
          </template>
          <span>Sair</span>
        </v-tooltip>
      </v-toolbar-items>
    </v-toolbar>

    <v-content>
      <v-container fluid>
        <v-layout justify-center align-center>
          <v-flex xs12>
            <partners-list />
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import firebase from 'firebase/app';
import 'firebase/auth';
import PartnersList from "@/components/PartnersList.vue";
import AdminNavigationMenu from "@/components/AdminNavigationMenu.vue";

export default {
  data: function() {
    return {
      drawer: true,
      search: ""
    };
  },
  computed:{
    userEmail: function(){
      return firebase.auth().currentUser.email;
    }
  },
  methods: {
    logout: function() {
      firebase.auth().signOut();
      this.$router.replace("login");
    }
  },
  components: {
    PartnersList,
    AdminNavigationMenu
  }
};
</script>



<style>
nav.v-toolbar {
  background-image: url(/logo-novo.png);
  background-size: 5rem;
  background-position: 1rem center;
}
</style>